import type { IntlShape } from 'react-intl';

export interface BulkTravellerResult {
  id: string;
  name: string;
  status: 'success' | 'failed';
  message?: string;
}

export const RECENT_OPERATION_SAMPLE_SIZE = 5;
export const SHOW_REMAINING_TIME_MIN_ITEMS = 10;

export const getTravellerDisplayName = (
  traveller: { first_name?: string; last_name?: string },
  anonymousLabel: string,
): string => {
  const name = [traveller.first_name, traveller.last_name]
    .filter(Boolean)
    .join(' ');
  return name || anonymousLabel;
};

export const getRemainingDurationMs = (
  durations: number[],
  remainingCount: number,
): number => {
  if (remainingCount <= 0 || durations.length === 0) {
    return 0;
  }

  const averageDuration =
    durations.reduce((total, duration) => total + duration, 0) /
    durations.length;

  return averageDuration * remainingCount;
};

export const formatRemainingTimeLabel = (
  remainingMs: number | null,
  formatMessage: IntlShape['formatMessage'],
): string | null => {
  if (remainingMs === null || remainingMs <= 0) {
    return null;
  }

  const seconds = Math.max(1, Math.round(remainingMs / 1000));
  if (seconds < 60) {
    return formatMessage(
      {
        defaultMessage:
          'Cirka {seconds, plural, one {# sekund} other {# sekunder}} kvar',
      },
      { seconds },
    );
  }

  const minutes = Math.round(seconds / 60);
  if (minutes < 60) {
    return formatMessage(
      {
        defaultMessage:
          'Cirka {minutes, plural, one {# minut} other {# minuter}} kvar',
      },
      { minutes },
    );
  }

  const hours = Math.round(minutes / 60);
  return formatMessage(
    {
      defaultMessage:
        'Cirka {hours, plural, one {# timme} other {# timmar}} kvar',
    },
    { hours },
  );
};
